import { Input } from "@/components/ui/input";
import { useFormContext, Controller } from "react-hook-form";

const DateOfBirthFields = () => {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  const hasError = !!errors.date_of_birth;

  return (
    <div className="space-y-2">
      <label className="block text-sm font-medium text-gray-700 font-verona">
        Date of Birth *
      </label>
      <Controller
        name="date_of_birth"
        control={control}
        render={({ field }) => (
          <Input
            type="date"
            error={hasError}
            className="font-verona"
            value={field.value ? new Date(field.value).toISOString().split('T')[0] : ''}
            onChange={(e) => {
              const dateValue = e.target.value ? new Date(e.target.value) : null;
              field.onChange(dateValue);
            }}
          />
        )}
      />
      {hasError && (
        <p className="text-red-500 text-sm font-verona">
          {errors.date_of_birth?.message as string}
        </p>
      )}
    </div>
  );
};

export default DateOfBirthFields;